import { Maximize2 } from "lucide-react";
import { useState, type ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function ExpandableMedia({
  children,
  className = "",
  description,
  label,
}: {
  children: ReactNode;
  className?: string;
  description?: string;
  label: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <button
        aria-label={`Expand ${label}`}
        className={`expandable-media ${className}`}
        onClick={() => setOpen(true)}
        title={`Expand ${label}`}
        type="button"
      >
        {children}
        <span aria-hidden="true" className="media-expand-icon"><Maximize2 /></span>
      </button>
      <DialogContent className="media-lightbox" showCloseButton>
        <DialogHeader>
          <DialogTitle>{label}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="media-lightbox-stage">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
